import React, { useEffect, useState } from 'react'
import { TextField, InputAdornment, IconButton } from '@mui/material'
import { SearchIcon } from '@/src/assets/icons'

interface CustomSearchBarProps {
  placeholder?: string
  classes?: string
  onSearch: (searchTerm: string) => void
  defaultValue?: string
  /** When true, drop the hardcoded 18rem/19.063rem width so the bar fills its parent. */
  fluid?: boolean
  /** Override default fixed width with Tailwind classes (e.g. "w-full lg:flex-1") */
  widthClass?: string
  /** Apply to the outer wrapper. Useful for flex-1 behaviour. */
  wrapperClassName?: string
}

const CustomSearchBar = ({
  placeholder,
  classes = '',
  onSearch,
  defaultValue,
  fluid = false,
  widthClass,
  wrapperClassName
}: CustomSearchBarProps) => {
  const [inputValue, setInputValue] = useState<string>(defaultValue ?? '')

  // Sync from parent. Use a ref-style nullish coalesce so passing ''
  // explicitly resets the field — required for "discard changes" /
  // "clear search" flows that need the chip + box to disappear in
  // lockstep. Previously the effect bailed on falsy defaults and the
  // input retained its last typed value.
  useEffect(() => {
    setInputValue(defaultValue ?? '')
  }, [defaultValue])

  // Handle user typing (instant) + debounced search
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value
    setInputValue(val) // instant update
    onSearch(val) // debounced parent update
  }
  return (
    <div className={wrapperClassName ?? (fluid ? 'w-full' : 'w-full sm:w-auto')}>
      <TextField
        placeholder={placeholder || 'Search...'}
        variant="outlined"
        fullWidth
        color="primary"
        value={inputValue}
        autoComplete={'off'}
        onChange={handleChange}
        className={widthClass ?? (fluid ? 'w-full' : 'w-full sm:w-[19.063rem]')}
        InputProps={{
          className: `rounded-full text-[#565E6D] h-[44px] bg-[#07004D14] ${classes} `,
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon className="w-[1.125rem] h-[1.125rem] fill-primary-main text-black" />
            </InputAdornment>
          )
        }}
      />
    </div>
  )
}

export default CustomSearchBar
